import {get} from 'svelte/store'
import {
  activeTags,
  countByGroup,
  flowId,
  globalSearch,
  isDirtySearch,
  list,
  ordering,
  pagination,
  tags
} from "../../../stores";
import {api} from "../../../../helpers";

export const searchPublications = async ({page = 1, orderingGroup, feedGroup = '', wikiPage = 0}) => {
  let path = `/api/v1/publication/feed/list/?page=${page}`

  const tags = get(activeTags)
  const idFlow = get(flowId)
  const sort = get(ordering)
  const searchByText = get(globalSearch)

  for (let tag of tags) {
    if (tags.length) {
      path += `&feed_tags=${tag}`
    }
  }

  if (wikiPage) {
    path += `&wiki_page=${wikiPage}`
  }

  if (idFlow) {
    path += `&flows=${idFlow}`
  }

  if (sort) {
    path += `&ordering=${sort}`;
  }

  if (searchByText.length) {
    path += `&full_text_search=${searchByText}`
  }

  path += `&ordering_group=${orderingGroup}`

  if (feedGroup) {
    path += `&feed_group=${feedGroup}`
  }

  const response = await api(path)
  const data = await response.json();
  const sortedByFix = data.results.sort((a, b) => b.fix - a.fix)

  list.update((n) => [...n, ...sortedByFix])
  pagination.set(data.pagination)
  countByGroup.set(data.count_by_group)
}

export const getTags = async () => {
    const response = await api('/api/v1/feed/tag/list/')
    const data = await response.json()

    tags.set(data)
};

export const resetSearch = () => {
  globalSearch.set('')
  isDirtySearch.set(false)
  activeTags.set([])
}